import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromGraphql from "./citizens-services-result.graphql";
import * as fromActions from "./citizens-services-result.actions";
import { map, switchMap } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { ResponseCodeService } from 'src/app/services/response-code.service';
import { AppState } from 'src/app/store/reducers';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';


@Injectable()
export class CitizensServicesResultEffects {

  citizenGetServicesResults$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetServicesResults),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITIZEN_SERVICES_RESULT,
        fetchPolicy: 'network-only',
        variables:{
          serviceUniqueId:action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.citizenGetServicesResults
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensServicesResults({ citizensServicesResults: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
